import { render, staticRenderFns } from "./MathFormulaInput.vue?vue&type=template&id=327ba412&scoped=true"
import script from "./MathFormulaInput.vue?vue&type=script&lang=js"
export * from "./MathFormulaInput.vue?vue&type=script&lang=js"
import style0 from "./MathFormulaInput.vue?vue&type=style&index=0&id=327ba412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ba412",
  null
  
)

export default component.exports